import React from "react";
import styled from "styled-components";
import { Icon } from "../../../components/Icon";
import { ContentEngagement } from "../../../components/ContentEngagement";
const _Availability = ({ title, links, className }) => (React.createElement("div", { className: className, "data-testid": "availability-wrapper" },
    React.createElement("div", { className: "availability-box", "data-testid": "availability-box" },
        React.createElement("fieldset", null,
            React.createElement("legend", { "data-testid": "availability-box-header" }, title),
            React.createElement("ul", null, links?.map((icon, index) => icon.link && (React.createElement("li", { key: `icon-${icon.iconName}-${index}` },
                React.createElement(ContentEngagement, { key: icon.iconName, action: icon.link?.action, contentAnalytics: {
                        id: `game-detail-masthead-availability-${icon?.iconName}`,
                        title: icon.link?.title,
                        uiType: "iconLink",
                        action: icon.link.action,
                    } }, icon.iconName && React.createElement(Icon, { name: icon.iconName, title: icon.link?.title }))))))))));
export const Availability = styled(_Availability) ``;
//# sourceMappingURL=Availability.js.map